module.exports = __webpack_public_path__ + "static/img/新闻3@2xs.e9cd9af.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/新闻3@2xs.png
// module id = MG46
// module chunks = 0